export const META_SOURCE_UPLOAD = 'RELEASE_NOTE_UPLOAD';
